import { buttonStyles } from "shared/styles/buttonStyles";
import styled, { css } from "styled-components";

export const StyledButton = styled.button(
  ({ theme, customStyles }) => css`
    ${buttonStyles({ theme })}
    ${customStyles && customStyles(theme)}
  `
);
